import { all } from 'redux-saga/effects';

import sistema from './sistema/combineSaga';
import localidade from './localidade/combineSaga';

export default all([sistema, localidade]);
